export default "__VITE_ASSET__Cuq8gdN0__"